<div class="title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor"> {{ sectionTitle }} </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div id="notes-list">
    <div class="accordion-print-preview" *ngFor="let subsection of notesSubsections; let accordionIndex = index">
        <h2 class="accordion-title" stylePreference [style.color]="printOptions.styleOptions.titleColor">
            {{ subsection.title }}
        </h2>
        <div *ngFor="let component of subsection.components; let componentIndex = index">
            <div
                class="component-title"
                *ngIf="component.componentTitle"
                [style.color]="printOptions.styleOptions.titleColor"
            >
                {{ component.componentTitle }}
            </div>
            <div class="component-print-preview" *ngIf="component.componentType === 'RT' && component.data != null">
                <div
                    [innerHtml]="component.data | safeHtml"
                    [style.--selected-background-color]="printOptions.styleOptions.backgroundColor"
                    [style.color]="printOptions.styleOptions.textColor"
                ></div>
            </div>
            <div
                class="component-print-preview"
                *ngIf="
                    component.componentType === 'S' ||
                    component.componentType === 'FT' ||
                    component.componentType === 'FLI'
                "
            >
                <div class="fli-print-preview">
                    <aumico-notes-component-display
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.data"
                        [noPreviousData]="noPreviousData"
                        [isFxFormat]="component.isFxFormat === true"
                    ></aumico-notes-component-display>
                </div>
            </div>
            <div class="component-print-preview" *ngIf="component.componentType === 'E'">
                <div class="fli-print-preview">
                    <aumico-notes-equity-display
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.data"
                        [noPreviousData]="noPreviousData"
                    ></aumico-notes-equity-display>
                </div>
            </div>
            <div class="component-print-preview" *ngIf="component.componentType === 'MS'">
                <div class="fli-print-preview">
                    <aumico-notes-movement-schedule-display
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.tables"
                        [noPreviousData]="noPreviousData"
                    ></aumico-notes-movement-schedule-display>
                </div>
            </div>
            <div
                class="component-print-preview"
                *ngIf="component.componentType === 'I' || component.componentType === 'I_NOP'"
            >
                <div class="fli-print-preview">
                    <aumico-notes-input-display
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.data"
                    ></aumico-notes-input-display>
                </div>
            </div>
            <div class="component-print-preview" *ngIf="component.componentType === 'ST'">
                <div
                    class="fli-print-preview"
                    class="{{ 'accordion' + accordionIndex + '-' + 'component' + componentIndex }}"
                >
                    <aumico-notes-super-table-display
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.data"
                    ></aumico-notes-super-table-display>
                    <aumico-notes-super-table-display
                        *ngIf="component.data.previousYear != null"
                        [printOptionStyles]="printOptions"
                        [sectionNotes]="component.data.previousYear"
                    ></aumico-notes-super-table-display>
                </div>
            </div>
        </div>
    </div>
</div>
